import { render, staticRenderFns } from "./BatchPriceEditor.vue?vue&type=template&id=1dd072d6"
import script from "./BatchPriceEditor.vue?vue&type=script&lang=js"
export * from "./BatchPriceEditor.vue?vue&type=script&lang=js"
import style0 from "./BatchPriceEditor.vue?vue&type=style&index=0&id=1dd072d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports